import { useState } from 'react'

/**
 * Hook to trigger a full remount of a react component, clearing state
 * Returns a pair of the key to pass to the component that will be remounted
 * and the function to trigger the remount
 * [renderKey, forceRemount] = useForceRemount()
 *
 * <div key={renderKey} onClick={() => forceRemount()}>
 *
 * @returns [number , () => void]
 */
const useForceRemount = (): [number, () => void] => {
  const [value, setValue] = useState(0)
  return [value, () => setValue(value + 1)] // update state to force render
}
export default useForceRemount
